export { DMS_MODULE } from '../constants';
export const CRUMB_LABEL_KEY = 'edtHeslo';
export const NAME = 'ZmenaHesla';
